import { render, staticRenderFns } from "./instagram-business-fields.vue?vue&type=template&id=1a1dc314&scoped=true&"
import script from "./instagram-business-fields.vue?vue&type=script&lang=js&"
export * from "./instagram-business-fields.vue?vue&type=script&lang=js&"
import style0 from "./instagram-business-fields.vue?vue&type=style&index=0&id=1a1dc314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1dc314",
  null
  
)

export default component.exports